export default __webpack_public_path__ + "static/media/mask-mobile.2567069b.png";